import {
  ChangeDetectionStrategy,
  Component, ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output, ViewChild
} from '@angular/core';
import { DropHintsComponent } from '@shared/components/email-search-input/drop-hints/drop-hints.component';
import { MetaService } from '@app/@shared/services/meta.service';
import { RegularExpressions } from '@shared/expresions/regular-expressions';
import {KEYBOARD_EVENTS} from '@shared/enums';

@Component({
    selector: 'app-email-search-input',
    templateUrl: './email-search-input.component.html',
    styleUrls: ['./email-search-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EmailSearchInputComponent implements OnInit {

  @Output()
  emailsChange: EventEmitter<string[]> = new EventEmitter<string[]>();

  @Output()
  invalidEmailsChange: EventEmitter<string[]> = new EventEmitter<string[]>();

  @Input()
  chipRegex: RegExp = RegularExpressions.email;

  @Input()
  splitRegex: RegExp = RegularExpressions.splitChips;

  @Input()
  placeholder = '';

  @ViewChild(DropHintsComponent)
  dropSuggester: DropHintsComponent;

  @ViewChild('searchInput', {static: true})
  searchElement: ElementRef;

  @ViewChild('tagsContainer', {static: true})
  tagsContainerElement: ElementRef;

  textInput = '';

  isFoundResultSearchShown = false;
  chips: string[] = [];
  isLastChipSelected = false;
  suggestions: any;
  isTagInputFocused = false;

  constructor(
    private metaService: MetaService
  ) {}

  ngOnInit() {
    this.metaService.getBestFriends().subscribe(friendsList => {
      this.suggestions = friendsList;
    });
  }

  handleValueChanged($event: any) {
    this.textInput = $event.target.value;
    const tokens = this. textInput.split(this.splitRegex);
    if (tokens.length > 1) {
      tokens.filter(token => token.length > 0).forEach(token => this.addChip(token));
    } else if (tokens.length === 1) {
      this.showTypeahead();
    }
    this.isLastChipSelected = false;
  }

  addChip(newChip?: any) {
    if (!newChip) {
      newChip = this.textInput.trim();
    }
    if (newChip) {
      if (!this.chips.includes(newChip)) {
        this.chips =
          [
            ...this.chips,
            newChip
          ];
      }
    }
    this.searchElement.nativeElement.value = '';
    this.textInput = '';
    this.closeTypeAhead();
    this.emitEmailsChange();
  }

  closeTypeAhead() {
    this.isFoundResultSearchShown = false;
  }

  showTypeahead() {
    this.isFoundResultSearchShown = true;
    if (this.dropSuggester) {
      this.dropSuggester.update(this.chips, this.textInput);
    }
  }

  removeChipByClick(data: string) {
    this.chips = this.chips.filter(chip => chip !== data);
    this.emitEmailsChange();
  }

  selectOrRemoveLastChip() {
    if (this.textInput.length === 0) {
      if (!this.isLastChipSelected) {
        this.isLastChipSelected = true;
      } else {
        this.chips.pop();
        this.emitEmailsChange();
      }
    }
  }

  emitEmailsChange() {
    if (this.dropSuggester) {
      this.dropSuggester.update(this.chips, this.textInput);
    }
    this.isLastChipSelected = false;
    const invalidItems = this.chips.filter(chip => !this.chipRegex.test(chip));
    this.emailsChange.emit( this.chips );
    this.invalidEmailsChange.emit( invalidItems );
  }

  takeSuggestion(event: string) {
    this.addChip(event);
  }

  type($event: KeyboardEvent) {
    switch ($event.key) {
      case KEYBOARD_EVENTS.ENTER: {
        const suggestion = this.dropSuggester.suggest();
        if (suggestion) {
          this.textInput = suggestion;
        }
        this.addChip();
        break;
      }
      case KEYBOARD_EVENTS.TAB: {
        if(this.textInput.length > 0) {
          this.addChip();
          $event.preventDefault();
          $event.stopPropagation();
        }
        break;
      }
      case KEYBOARD_EVENTS.ARROW_DOWN: {
        if(this.isFoundResultSearchShown) {
          this.dropSuggester.goDown();
        }
        break;
      }
      case KEYBOARD_EVENTS.ARROW_UP: {
        if(this.isFoundResultSearchShown) {
          this.dropSuggester.goUp();
        }
        break;
      }
    }
  }

  getDropdownPositionOffset() {
    const maxLeftPosition = window.innerWidth - 310;
    const position =
      this.searchElement.nativeElement.getBoundingClientRect().left -
      this.tagsContainerElement.nativeElement.getBoundingClientRect().left;
    return (position < maxLeftPosition ? position : maxLeftPosition) + 'px';
  }
}
